// This filter removes any parentheses and whitespaces from phone number and prepend country code.
export default value => {
  let clearValue = value.replace(/[()\s]/g, '')

  let countryCode = 90

  if (import.meta.env.VITE_COUNTRY === 'ro') {
    countryCode = 40
  }

  clearValue = countryCode + clearValue

  return clearValue
}
